<template>
  <button
    :class="classes"
    @click.prevent="$emit('clicked')"
  >
    {{ caption }}
  </button>
</template>
<script>
export default {
  name: "Button",
  props: {
    caption: {
      type: String,
      required: true
    },
    uppercase: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    classes: function() {
      let result = "quiz__tile__button";
      this.uppercase && (result += " uppercase");
      return result;
    }
  },
};
</script>